import React from 'react';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const CompanyHero = ({ company, onStartRegistration }) => {
  return (
    <div className="relative bg-gradient-to-br from-primary/10 via-background to-secondary/10 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary rounded-full blur-3xl"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full">
              <div className="w-2 h-2 bg-primary rounded-full animate-pulse"></div>
              <span className="text-sm font-medium text-primary">Welcome to {company?.name}</span>
            </div>
            
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-foreground leading-tight">
              {company?.heroTitle}
            </h1>
            
            <p className="text-lg text-muted-foreground leading-relaxed">
              {company?.heroDescription}
            </p>
            
            <div className="flex flex-wrap gap-4 pt-4">
              <Button 
                variant="default" 
                size="lg"
                iconName="ArrowRight"
                iconPosition="right"
                onClick={onStartRegistration}
                className="shadow-lg hover:shadow-xl transition-shadow"
              >
                Start Your Journey
              </Button>
              
              <Button 
                variant="outline" 
                size="lg"
                iconName="Info"
                iconPosition="left"
              >
                Learn More
              </Button>
            </div>
            
            <div className="flex items-center gap-6 pt-6 border-t border-border">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-success/10 rounded-full flex items-center justify-center">
                  <span className="text-success font-bold text-lg">{company?.stats?.employees}+</span>
                </div>
                <span className="text-sm text-muted-foreground">Team Members</span>
              </div>
              
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-accent/10 rounded-full flex items-center justify-center">
                  <span className="text-accent font-bold text-lg">{company?.stats?.projects}+</span>
                </div>
                <span className="text-sm text-muted-foreground">Projects Delivered</span>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-secondary/20 rounded-3xl blur-2xl"></div>
            <div className="relative bg-card rounded-3xl shadow-2xl overflow-hidden border border-border">
              <Image 
                src={company?.heroImage}
                alt={company?.heroImageAlt}
                className="w-full h-[400px] lg:h-[500px] object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyHero;